
export const SEPA_COUNTRY_LIST = [
    { code: "PT50", name: "Portugal" },
    { code: "FR", name: "França" },
    { code: "CH", name: "Suíça" },
    { code: "GB", name: "Reino Unido" },
    { code: "DE", name: "Alemanha" },
    { code: "AD", name: "Andorra" },
    { code: "AT", name: "Áustria" },
    { code: "BE", name: "Bélgica" },
    { code: "BG", name: "Bulgária" },
    { code: "CY", name: "Chipre" },
    { code: "HR", name: "Croácia" },
    { code: "CZ", name: "Czechia" },
    { code: "DK", name: "Dinamarca" },
    { code: "ES", name: "Espanha" },
    { code: "SK", name: "Eslováquia" },
    { code: "SI", name: "Eslovénia" },
    { code: "EE", name: "Estónia" },
    { code: "FI", name: "Finlândia" },
    { code: "GI", name: "Gibraltar" },
    { code: "GR", name: "Grécia" },
    { code: "HU", name: "Hungria" },
    { code: "IE", name: "Irlanda" },
    { code: "IS", name: "Islândia" },
    { code: "IT", name: "Itália" },
    { code: "LV", name: "Letônia" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Lituânia" },
    { code: "LU", name: "Luxemburgo" },
    { code: "MT", name: "Malta" },
    { code: "MC", name: "Mónaco" },
    { code: "NO", name: "Noruega" },
    { code: "NL", name: "Países Baixos" },
    { code: "PL", name: "Polónia" },
    { code: "RO", name: "Roménia" },
    { code: "SM", name: "San Marino" },
    { code: "SE", name: "Suécia" }
    
];

export const EU_WITH_PT_LIST = [
    { code: "Portugal", name: "Portugal" },
    { code: "Alemanha", name: "Alemanha" },
    { code: "Áustria", name: "Áustria" },
    { code: "Bélgica", name: "Bélgica" },
    { code: "Bulgária", name: "Bulgária" },
    { code: "Chipre", name: "Chipre" },
    { code: "Croácia", name: "Croácia" },
    { code: "Czechia", name: "Czechia" },
    { code: "Dinamarca", name: "Dinamarca" },
    { code: "Eslováquia", name: "Eslováquia" },
    { code: "Eslovênia", name: "Eslovênia" },
    { code: "Espanha", name: "Espanha" },
    { code: "Estônia", name: "Estônia" },
    { code: "Finlândia", name: "Finlândia" },
    { code: "França", name: "França" },
    { code: "Grécia", name: "Grécia" },
    { code: "Hungria", name: "Hungria" },
    { code: "Irlanda", name: "Irlanda" },
    { code: "Islândia", name: "Islândia" },
    { code: "Itália", name: "Itália" },
    { code: "Letônia", name: "Letônia" },
    { code: "Liechtenstein", name: "Liechtenstein" },
    { code: "Lituânia", name: "Lituânia" },
    { code: "Luxemburgo", name: "Luxemburgo" },
    { code: "Malta", name: "Malta" },
    { code: "Noruega", name: "Noruega" },
    { code: "Países Baixos", name: "Países Baixos" },
    { code: "Polônia", name: "Polônia" },
    { code: "Romênia", name: "Romênia" },
    { code: "Suécia", name: "Suécia" },
    { code: "Suíça", name: "Suíça" }
];

export const EU_WITHOUT_PT_LIST = [
    { code: "Alemanha", name: "Alemanha" },
    { code: "Áustria", name: "Áustria" },
    { code: "Bélgica", name: "Bélgica" },
    { code: "Bulgária", name: "Bulgária" },
    { code: "Chipre", name: "Chipre" },
    { code: "Croácia", name: "Croácia" },
    { code: "Czechia", name: "Czechia" },
    { code: "Dinamarca", name: "Dinamarca" },
    { code: "Eslováquia", name: "Eslováquia" },
    { code: "Eslovênia", name: "Eslovênia" },
    { code: "Espanha", name: "Espanha" },
    { code: "Estônia", name: "Estônia" },
    { code: "Finlândia", name: "Finlândia" },
    { code: "França", name: "França" },
    { code: "Grécia", name: "Grécia" },
    { code: "Hungria", name: "Hungria" },
    { code: "Irlanda", name: "Irlanda" },
    { code: "Islândia", name: "Islândia" },
    { code: "Itália", name: "Itália" },
    { code: "Letônia", name: "Letônia" },
    { code: "Liechtenstein", name: "Liechtenstein" },
    { code: "Lituânia", name: "Lituânia" },
    { code: "Luxemburgo", name: "Luxemburgo" },
    { code: "Malta", name: "Malta" },
    { code: "Noruega", name: "Noruega" },
    { code: "Países Baixos", name: "Países Baixos" },
    { code: "Polônia", name: "Polônia" },
    { code: "Romênia", name: "Romênia" },
    { code: "Suécia", name: "Suécia" },
    { code: "Suíça", name: "Suíça" }
];

export const NON_EU_LIST = [
    { code: "Afeganistão", name: "Afeganistão" },
    { code: "África do Sul", name: "África do Sul" },
    { code: "Albânia", name: "Albânia" },
    { code: "Andorra", name: "Andorra" },
    { code: "Angola", name: "Angola" },
    { code: "Anguilla", name: "Anguilla" },
    { code: "Antigua e Deps", name: "Antigua e Deps" },
    { code: "Arábia Saudita", name: "Arábia Saudita" },
    { code: "Argélia", name: "Argélia" },
    { code: "Argentina", name: "Argentina" },
    { code: "Arménia", name: "Arménia" },
    { code: "Aruba", name: "Aruba" },
    { code: "Austrália", name: "Austrália" },
    { code: "Azerbaijão", name: "Azerbaijão" },
    { code: "Bahamas", name: "Bahamas" },
    { code: "Bahrain", name: "Bahrain" },
    { code: "Bangladesh", name: "Bangladesh" },
    { code: "Barbados", name: "Barbados" },
    { code: "Belize", name: "Belize" },
    { code: "Benin", name: "Benin" },
    { code: "Bermudas", name: "Bermudas" },
    { code: "Bielorússia", name: "Bielorússia" },
    { code: "Bolívia", name: "Bolívia" },
    { code: "Bósnia Herzegovina", name: "Bósnia Herzegovina" },
    { code: "Botswana", name: "Botswana" },
    { code: "Brasil", name: "Brasil" },
    { code: "Brunei", name: "Brunei" },
    { code: "Burkina", name: "Burkina" },
    { code: "Burundi", name: "Burundi" },
    { code: "Butão", name: "Butão" },
    { code: "Cabo Verde", name: "Cabo Verde" },
    { code: "Camarões", name: "Camarões" },
    { code: "Camboja", name: "Camboja" },
    { code: "Canadá", name: "Canadá" },
    { code: "Catar", name: "Catar" },
    { code: "Cazaquistão", name: "Cazaquistão" },
    { code: "Chade", name: "Chade" },
    { code: "Chile", name: "Chile" },
    { code: "China", name: "China" },
    { code: "Cidade do Vaticano", name: "Cidade do Vaticano" },
    { code: "Colômbia", name: "Colômbia" },
    { code: "Comoros", name: "Comoros" },
    { code: "Congo", name: "Congo" },
    { code: "Coreia do Norte", name: "Coreia do Norte" },
    { code: "Coreia do Sul", name: "Coreia do Sul" },
    { code: "Costa do Marfim", name: "Costa do Marfim" },
    { code: "Costa Rica", name: "Costa Rica" },
    { code: "Cuba", name: "Cuba" },
    { code: "Curaçao", name: "Curaçao" },
    { code: "Djibouti", name: "Djibouti" },
    { code: "Dominica", name: "Dominica" },
    { code: "Egito", name: "Egito" },
    { code: "El Salvador", name: "El Salvador" },
    { code: "Emirados Árabes Unidos", name: "Emirados Árabes Unidos" },
    { code: "Equador", name: "Equador" },
    { code: "Eritreia", name: "Eritreia" },
    { code: "Estados Unidos", name: "Estados Unidos" },
    { code: "Etiópia", name: "Etiópia" },
    { code: "Federação Russa", name: "Federação Russa" },
    { code: "Fiji", name: "Fiji" },
    { code: "Filipinas", name: "Filipinas" },
    { code: "Gabão", name: "Gabão" },
    { code: "Gâmbia", name: "Gâmbia" },
    { code: "Gana", name: "Gana" },
    { code: "Georgia", name: "Georgia" },
    { code: "Gibraltar", name: "Gibraltar" },
    { code: "Grenada", name: "Grenada" },
    { code: "Gronelândia", name: "Gronelândia" },
    { code: "Guadalupe", name: "Guadalupe" },
    { code: "Guam", name: "Guam" },
    { code: "Guatemala", name: "Guatemala" },
    { code: "Guiana", name: "Guiana" },
    { code: "Guiana Francesa", name: "Guiana Francesa" },
    { code: "Guiné", name: "Guiné" },
    { code: "Guiné Equatorial", name: "Guiné Equatorial" },
    { code: "Guiné-bissau", name: "Guiné-bissau" },
    { code: "Haiti", name: "Haiti" },
    { code: "Honduras", name: "Honduras" },
    { code: "Hong Kong", name: "Hong Kong" },
    { code: "Iémen", name: "Iémen" },
    { code: "Ilhas Caimão", name: "Ilhas Caimão" },
    { code: "Ilhas Cook", name: "Ilhas Cook" },
    { code: "Ilhas Faroé", name: "Ilhas Faroé" },
    { code: "Ilhas Marshall", name: "Ilhas Marshall" },
    { code: "Ilhas Salomão", name: "Ilhas Salomão" },
    { code: "Índia", name: "Índia" },
    { code: "Indonésia", name: "Indonésia" },
    { code: "Irão", name: "Irão" },
    { code: "Iraque", name: "Iraque" },
    { code: "Israel", name: "Israel" },
    { code: "Jamaica", name: "Jamaica" },
    { code: "Japão", name: "Japão" },
    { code: "Jordânia", name: "Jordânia" },
    { code: "Kiribati", name: "Kiribati" },
    { code: "Kuwait", name: "Kuwait" },
    { code: "Laos", name: "Laos" },
    { code: "Lesoto", name: "Lesoto" },
    { code: "Líbano", name: "Líbano" },
    { code: "Libéria", name: "Libéria" },
    { code: "Líbia", name: "Líbia" },
    { code: "Macau", name: "Macau" },
    { code: "Macedonia", name: "Macedonia" },
    { code: "Madagáscar", name: "Madagáscar" },
    { code: "Malásia", name: "Malásia" },
    { code: "Malawi", name: "Malawi" },
    { code: "Maldivas", name: "Maldivas" },
    { code: "Mali", name: "Mali" },
    { code: "Marrocos", name: "Marrocos" },
    { code: "Martinica", name: "Martinica" },
    { code: "Maurício", name: "Maurício" },
    { code: "Mauritânia", name: "Mauritânia" },
    { code: "México", name: "México" },
    { code: "Mianmar", name: "Mianmar" },
    { code: "Micronésia", name: "Micronésia" },
    { code: "Moçambique", name: "Moçambique" },
    { code: "Moldova", name: "Moldova" },
    { code: "Mongólia", name: "Mongólia" },
    { code: "Montenegro", name: "Montenegro" },
    { code: "Namibia", name: "Namibia" },
    { code: "Nauru", name: "Nauru" },
    { code: "Nepal", name: "Nepal" },
    { code: "Nicarágua", name: "Nicarágua" },
    { code: "Níger", name: "Níger" },
    { code: "Nigéria", name: "Nigéria" },
    { code: "Nova Zelândia", name: "Nova Zelândia" },
    { code: "Omã", name: "Omã" },
    { code: "Palau", name: "Palau" },
    { code: "Palestina", name: "Palestina" },
    { code: "Panamá", name: "Panamá" },
    { code: "Papua Nova Guiné", name: "Papua Nova Guiné" },
    { code: "Paquistão", name: "Paquistão" },
    { code: "Paraguai", name: "Paraguai" },
    { code: "Peru", name: "Peru" },
    { code: "Polinésia Francesa", name: "Polinésia Francesa" },
    { code: "Porto Rico", name: "Porto Rico" },
    { code: "Quénia", name: "Quénia" },
    { code: "Quirguistão", name: "Quirguistão" },
    { code: "Reino Unido", name: "Reino Unido" },
    { code: "Rep. Centro-Africano", name: "Rep. Centro-Africano" },
    { code: "Rep. Democrática Congo", name: "Rep. Democrática Congo" },
    { code: "República Dominicana", name: "República Dominicana" },
    { code: "Reunião", name: "Reunião" },
    { code: "Ruanda", name: "Ruanda" },
    { code: "Samoa", name: "Samoa" },
    { code: "Samoa Americana", name: "Samoa Americana" },
    { code: "Santa Lúcia", name: "Santa Lúcia" },
    { code: "São Marino", name: "São Marino" },
    { code: "São Tomé e Príncipe", name: "São Tomé e Príncipe" },
    { code: "São Vicente e Granadinas", name: "São Vicente e Granadinas" },
    { code: "Senegal", name: "Senegal" },
    { code: "Serra Leoa", name: "Serra Leoa" },
    { code: "Sérvia", name: "Sérvia" },
    { code: "Seychelles", name: "Seychelles" },
    { code: "Singapura", name: "Singapura" },
    { code: "Síria", name: "Síria" },
    { code: "Somália", name: "Somália" },
    { code: "Sri Lanka", name: "Sri Lanka" },
    { code: "Suazilândia", name: "Suazilândia" },
    { code: "Sudão", name: "Sudão" },
    { code: "Suriname", name: "Suriname" },
    { code: "Tahiti", name: "Tahiti" },
    { code: "Tailândia", name: "Tailândia" },
    { code: "Taiwan", name: "Taiwan" },
    { code: "Tajiquistão", name: "Tajiquistão" },
    { code: "Tanzânia", name: "Tanzânia" },
    { code: "Timor Leste", name: "Timor Leste" },
    { code: "Togo", name: "Togo" },
    { code: "Trinidad e Tobago", name: "Trinidad e Tobago" },
    { code: "Tunísia", name: "Tunísia" },
    { code: "Turcomenistão", name: "Turcomenistão" },
    { code: "Turquia", name: "Turquia" },
    { code: "Tuvalu", name: "Tuvalu" },
    { code: "Ucrânia", name: "Ucrânia" },
    { code: "Uganda", name: "Uganda" },
    { code: "Uruguai", name: "Uruguai" },
    { code: "Uzbequistão", name: "Uzbequistão" },
    { code: "Vanuatu", name: "Vanuatu" },
    { code: "Venezuela", name: "Venezuela" },
    { code: "Vietname", name: "Vietname" },
    { code: "Zaire", name: "Zaire" },
    { code: "Zâmbia", name: "Zâmbia" },
    { code: "Zimbábue", name: "Zimbábue" }
];

export const PORTUGAL = { name: "Portugal", code: "Portugal" };

export const WORLD_LIST = [
    { code: "Portugal", name: "Portugal" },
    { code: "Afeganistão", name: "Afeganistão" },
    { code: "África do Sul", name: "África do Sul" },
    { code: "Albânia", name: "Albânia" },
    { code: "Alemanha", name: "Alemanha" },
    { code: "Andorra", name: "Andorra" },
    { code: "Angola", name: "Angola" },
    { code: "Anguilla", name: "Anguilla" },
    { code: "Antigua e Deps", name: "Antigua e Deps" },
    { code: "Arábia Saudita", name: "Arábia Saudita" },
    { code: "Argélia", name: "Argélia" },
    { code: "Argentina", name: "Argentina" },
    { code: "Arménia", name: "Arménia" },
    { code: "Aruba", name: "Aruba" },
    { code: "Austrália", name: "Austrália" },
    { code: "Áustria", name: "Áustria" },
    { code: "Azerbaijão", name: "Azerbaijão" },
    { code: "Bahamas", name: "Bahamas" },
    { code: "Bahrain", name: "Bahrain" },
    { code: "Bangladesh", name: "Bangladesh" },
    { code: "Barbados", name: "Barbados" },
    { code: "Bélgica", name: "Bélgica" },
    { code: "Belize", name: "Belize" },
    { code: "Benin", name: "Benin" },
    { code: "Bermudas", name: "Bermudas" },
    { code: "Bielorússia", name: "Bielorússia" },
    { code: "Bolívia", name: "Bolívia" },
    { code: "Bósnia Herzegovina", name: "Bósnia Herzegovina" },
    { code: "Botswana", name: "Botswana" },
    { code: "Brasil", name: "Brasil" },
    { code: "Brunei", name: "Brunei" },
    { code: "Bulgária", name: "Bulgária" },
    { code: "Burkina", name: "Burkina" },
    { code: "Burundi", name: "Burundi" },
    { code: "Butão", name: "Butão" },
    { code: "Cabo Verde", name: "Cabo Verde" },
    { code: "Camarões", name: "Camarões" },
    { code: "Camboja", name: "Camboja" },
    { code: "Canadá", name: "Canadá" },
    { code: "Catar", name: "Catar" },
    { code: "Cazaquistão", name: "Cazaquistão" },
    { code: "Chade", name: "Chade" },
    { code: "Chile", name: "Chile" },
    { code: "China", name: "China" },
    { code: "Chipre", name: "Chipre" },
    { code: "Cidade do Vaticano", name: "Cidade do Vaticano" },
    { code: "Colômbia", name: "Colômbia" },
    { code: "Comoros", name: "Comoros" },
    { code: "Congo", name: "Congo" },
    { code: "Coreia do Norte", name: "Coreia do Norte" },
    { code: "Coreia do Sul", name: "Coreia do Sul" },
    { code: "Costa do Marfim", name: "Costa do Marfim" },
    { code: "Costa Rica", name: "Costa Rica" },
    { code: "Croácia", name: "Croácia" },
    { code: "Cuba", name: "Cuba" },
    { code: "Curaçao", name: "Curaçao" },
    { code: "Dinamarca", name: "Dinamarca" },
    { code: "Djibouti", name: "Djibouti" },
    { code: "Dominica", name: "Dominica" },
    { code: "Egito", name: "Egito" },
    { code: "El Salvador", name: "El Salvador" },
    { code: "Emirados Árabes Unidos", name: "Emirados Árabes Unidos" },
    { code: "Equador", name: "Equador" },
    { code: "Eritreia", name: "Eritreia" },
    { code: "Eslováquia", name: "Eslováquia" },
    { code: "Eslovénia", name: "Eslovénia" },
    { code: "Espanha", name: "Espanha" },
    { code: "Estados Unidos", name: "Estados Unidos" },
    { code: "Estónia", name: "Estónia" },
    { code: "Etiópia", name: "Etiópia" },
    { code: "Federação Russa", name: "Federação Russa" },
    { code: "Fiji", name: "Fiji" },
    { code: "Filipinas", name: "Filipinas" },
    { code: "Finlândia", name: "Finlândia" },
    { code: "França", name: "França" },
    { code: "Gabão", name: "Gabão" },
    { code: "Gâmbia", name: "Gâmbia" },
    { code: "Gana", name: "Gana" },
    { code: "Georgia", name: "Georgia" },
    { code: "Gibraltar", name: "Gibraltar" },
    { code: "Grécia", name: "Grécia" },
    { code: "Grenada", name: "Grenada" },
    { code: "Gronelândia", name: "Gronelândia" },
    { code: "Guadalupe", name: "Guadalupe" },
    { code: "Guam", name: "Guam" },
    { code: "Guatemala", name: "Guatemala" },
    { code: "Guiana", name: "Guiana" },
    { code: "Guiana Francesa", name: "Guiana Francesa" },
    { code: "Guiné", name: "Guiné" },
    { code: "Guiné Equatorial", name: "Guiné Equatorial" },
    { code: "Guiné-bissau", name: "Guiné-bissau" },
    { code: "Haiti", name: "Haiti" },
    { code: "Holanda", name: "Holanda" },
    { code: "Honduras", name: "Honduras" },
    { code: "Hong Kong", name: "Hong Kong" },
    { code: "Hungria", name: "Hungria" },
    { code: "Iémen", name: "Iémen" },
    { code: "Ilhas Caimão", name: "Ilhas Caimão" },
    { code: "Ilhas Cook", name: "Ilhas Cook" },
    { code: "Ilhas Faroé", name: "Ilhas Faroé" },
    { code: "Ilhas Marshall", name: "Ilhas Marshall" },
    { code: "Ilhas Salomão", name: "Ilhas Salomão" },
    { code: "Índia", name: "Índia" },
    { code: "Indonésia", name: "Indonésia" },
    { code: "Irão", name: "Irão" },
    { code: "Iraque", name: "Iraque" },
    { code: "Irlanda", name: "Irlanda" },
    { code: "Islândia", name: "Islândia" },
    { code: "Israel", name: "Israel" },
    { code: "Itália", name: "Itália" },
    { code: "Jamaica", name: "Jamaica" },
    { code: "Japão", name: "Japão" },
    { code: "Jordânia", name: "Jordânia" },
    { code: "Kiribati", name: "Kiribati" },
    { code: "Kuwait", name: "Kuwait" },
    { code: "Laos", name: "Laos" },
    { code: "Lesoto", name: "Lesoto" },
    { code: "Letónia", name: "Letónia" },
    { code: "Líbano", name: "Líbano" },
    { code: "Libéria", name: "Libéria" },
    { code: "Líbia", name: "Líbia" },
    { code: "Liechtenstein", name: "Liechtenstein" },
    { code: "Lituânia", name: "Lituânia" },
    { code: "Luxemburgo", name: "Luxemburgo" },
    { code: "Macau", name: "Macau" },
    { code: "Macedonia", name: "Macedonia" },
    { code: "Madagáscar", name: "Madagáscar" },
    { code: "Malásia", name: "Malásia" },
    { code: "Malawi", name: "Malawi" },
    { code: "Maldivas", name: "Maldivas" },
    { code: "Mali", name: "Mali" },
    { code: "Malta", name: "Malta" },
    { code: "Marrocos", name: "Marrocos" },
    { code: "Martinica", name: "Martinica" },
    { code: "Maurício", name: "Maurício" },
    { code: "Mauritânia", name: "Mauritânia" },
    { code: "México", name: "México" },
    { code: "Mianmar", name: "Mianmar" },
    { code: "Micronésia", name: "Micronésia" },
    { code: "Moçambique", name: "Moçambique" },
    { code: "Moldova", name: "Moldova" },
    { code: "Mongólia", name: "Mongólia" },
    { code: "Montenegro", name: "Montenegro" },
    { code: "Namibia", name: "Namibia" },
    { code: "Nauru", name: "Nauru" },
    { code: "Nepal", name: "Nepal" },
    { code: "Nicarágua", name: "Nicarágua" },
    { code: "Níger", name: "Níger" },
    { code: "Nigéria", name: "Nigéria" },
    { code: "Noruega", name: "Noruega" },
    { code: "Nova Zelândia", name: "Nova Zelândia" },
    { code: "Omã", name: "Omã" },
    { code: "Palau", name: "Palau" },
    { code: "Palestina", name: "Palestina" },
    { code: "Panamá", name: "Panamá" },
    { code: "Papua Nova Guiné", name: "Papua Nova Guiné" },
    { code: "Paquistão", name: "Paquistão" },
    { code: "Paraguai", name: "Paraguai" },
    { code: "Peru", name: "Peru" },
    { code: "Polinésia Francesa", name: "Polinésia Francesa" },
    { code: "Polônia", name: "Polônia" },
    { code: "Porto Rico", name: "Porto Rico" },
    { code: "Quénia", name: "Quénia" },
    { code: "Quirguistão", name: "Quirguistão" },
    { code: "Reino Unido", name: "Reino Unido" },
    { code: "Rep. Centro-Africano", name: "Rep. Centro-Africano" },
    { code: "Rep. Democrática Congo", name: "Rep. Democrática Congo" },
    { code: "República Checa", name: "República Checa" },
    { code: "República Dominicana", name: "República Dominicana" },
    { code: "Reunião", name: "Reunião" },
    { code: "Romênia", name: "Romênia" },
    { code: "Ruanda", name: "Ruanda" },
    { code: "Samoa", name: "Samoa" },
    { code: "Samoa Americana", name: "Samoa Americana" },
    { code: "Santa Lúcia", name: "Santa Lúcia" },
    { code: "São Marino", name: "São Marino" },
    { code: "São Tomé e Príncipe", name: "São Tomé e Príncipe" },
    { code: "São Vicente e Granadinas", name: "São Vicente e Granadinas" },
    { code: "Senegal", name: "Senegal" },
    { code: "Serra Leoa", name: "Serra Leoa" },
    { code: "Sérvia", name: "Sérvia" },
    { code: "Seychelles", name: "Seychelles" },
    { code: "Singapura", name: "Singapura" },
    { code: "Síria", name: "Síria" },
    { code: "Somália", name: "Somália" },
    { code: "Sri Lanka", name: "Sri Lanka" },
    { code: "Suazilândia", name: "Suazilândia" },
    { code: "Sudão", name: "Sudão" },
    { code: "Suécia", name: "Suécia" },
    { code: "Suíça", name: "Suíça" },
    { code: "Suriname", name: "Suriname" },
    { code: "Tahiti", name: "Tahiti" },
    { code: "Tailândia", name: "Tailândia" },
    { code: "Taiwan", name: "Taiwan" },
    { code: "Tajiquistão", name: "Tajiquistão" },
    { code: "Tanzânia", name: "Tanzânia" },
    { code: "Timor Leste", name: "Timor Leste" },
    { code: "Togo", name: "Togo" },
    { code: "Trinidad e Tobago", name: "Trinidad e Tobago" },
    { code: "Tunísia", name: "Tunísia" },
    { code: "Turcomenistão", name: "Turcomenistão" },
    { code: "Turquia", name: "Turquia" },
    { code: "Tuvalu", name: "Tuvalu" },
    { code: "Ucrânia", name: "Ucrânia" },
    { code: "Uganda", name: "Uganda" },
    { code: "Uruguai", name: "Uruguai" },
    { code: "Uzbequistão", name: "Uzbequistão" },
    { code: "Vanuatu", name: "Vanuatu" },
    { code: "Venezuela", name: "Venezuela" },
    { code: "Vietname", name: "Vietname" },
    { code: "Zaire", name: "Zaire" },
    { code: "Zâmbia", name: "Zâmbia" },
    { code: "Zimbábue", name: "Zimbábue" }
];
